import { useState, useEffect } from "react";
import Loader from "components/Loader";
import { submitKeywordAnalysisRequest } from "services/buddyXApiHubService";
import HelpCard from "components/Cards/HelpCard";
import { Form } from "react-bootstrap";
import ArticleHeadlinesKeywordTable from "components/Tables/ArticleHeadlinesKeywordTable";
import MobileSupportTabBar from "components/TabBars/MobileSupportTabBar";
import Validator from "utils/Validator";
import classNames from "classnames";
import { css } from "aphrodite";
import pageStyles from "styles/pageStyles";
import { getInputFieldStyle, getButtonStyle } from "utils/formStyles";

export default function Page() {
  const [isFormValid, setIsFormValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    domainLink: "",
  });
  const [isResultGot, setIsResultGot] = useState(false);
  const [errors, setErrors] = useState({ keyword: "", webSite: "" });
  const [webSite, setWebSite] = useState("");
  const [showSearchItem, setShowSearchItem] = useState("");

  const [data, setData] = useState([
    "Maximizing Kitchen Storage Space: A Complete Guide",
    "yourwebsite.com/creative-kitchen-storage-solutions",
    "How to Organize Your Kitchen for Maximum Storage Efficiency", 
    "Top 5 Kitchen Storage Hacks for Small Spaces",
    "The Ultimate Guide to Decluttering Your Kitchen for Storage Success",
    "Essential Tips for Organizing Your Pantry",
    "Creative Ideas for Small Kitchen Storage",
    "How to Make the Most of Your Cabinet Space",
    "Best Practices for Organizing Kitchen Drawers",
    "Smart Solutions for Storing Kitchen Utensils",
  ]);
  const firstLevelTopic = "SEO";
  const secoundLevelTopic = "Title";
  const thirdLevelTopic = "URL";

  const [tabs, setTabs] = useState([
    {
      label: "Draft A",
      element: (
        <ArticleHeadlinesKeywordTable data={data} topic={thirdLevelTopic} />
      ),
    },
    {
      label: "Draft B",
      element: (
        <ArticleHeadlinesKeywordTable data={data} topic={thirdLevelTopic} />
      ),
    },
    {
      label: "Draft C",
      element: (
        <ArticleHeadlinesKeywordTable data={data} topic={thirdLevelTopic} />
      ),
    },
    {
      label: "Draft D",
      element: (
        <ArticleHeadlinesKeywordTable data={data} topic={thirdLevelTopic} />
      ),
    },
  ]);

  const handleWebSiteChange = (e) => {
    setWebSite(e.target.value);
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    let error = "";
    if (
      name === "webSite" &&
      !Validator.validateRequired(value, Validator.validateUrl)
    ) {
      error = "Invalid URL";
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  const handleReset = () => {
    setData([]);
    setIsResultGot(false);
    setWebSite("");
    setShowSearchItem("");
    setErrors({ webSite: "" });
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      console.log(formData);
      // const result = await submitKeywordAnalysisRequest(formData);
      // console.log("Data submitted successfully:", result);
      // setShowSearchItem(formData.domainLink)
      // setData(result);
      // setKeywords(formData.keyword);
      setIsResultGot(true);
    } catch (error) {
      console.error("Submission error:", error);
      setIsResultGot(false);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    let isValid = Validator.validateRequired(webSite, Validator.validateUrl);
    if (isValid) {
      setFormData({
        domainLink: webSite,
      });
    }
    setIsFormValid(isValid);
  }, [webSite]);

  return (
    <div className={classNames("container-fluid", css(pageStyles.container))}>
      <h1 className=" d-flex fw-normal justify-content-start align-items-center fw-bold">
        {secoundLevelTopic}
      </h1>
      <p className="fw-normal justify-content-start align-items-center">
        {firstLevelTopic} / {secoundLevelTopic} / <b>{thirdLevelTopic}</b>
      </p>
      <p className="fw-normal justify-content-start align-items-center">
        Find the most compelling <b> article headlines </b>
        tailored to your content, ensuring maximum click-through rates and
        engagement. Generate eye-catching titles that resonate with your
        audience and drive traffic to your site.
      </p>
      <div className="row">
        <div className="col-lg-9 col-md-10 col-sm-10">
          <HelpCard
            topic={"How To Use"}
            description={`${'"'}Article Headlines ${'"'} helps you craft compelling, optimised titles for your articles, boosting engagement and driving more traffic by improving click-through rates and search visibility.`}
            image={"/icon/pin.svg"}
          />
        </div>
      </div>
      <div className="p-2 mb-2 rounded">
        <div className="d-flex fw-bold mb-0">URL</div>
        <div className="row mb-2 align-items-end">
          <div className="mb-2">
            <p className="fw-normal justify-content-start align-items-center">
              Web site
            </p>
            <Form.Group>
              <div className="d-flex mt-2">
                <div className="col-sm-6 me-2">
                  <Form.Control
                    type="text"
                    name="webSite"
                    placeholder="Enter Web Site"
                    value={webSite}
                    onChange={handleWebSiteChange}
                    onBlur={handleBlur}
                    isInvalid={!!errors.webSite}
                    required
                    className="px-2"
                  />
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 mb-2 me-1">
                  <div className="d-flex justify-content-start align-items-end">
                    <button
                      type="button"
                      className="btn btn-dark me-1"
                      onClick={handleSubmit}
                      disabled={!isFormValid}
                    >
                      Search
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-dark me-1"
                      onClick={handleReset}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </Form.Group>
          </div>
        </div>
      </div>

      <div className="p-2">
        {showSearchItem !== "" && (
          <div>
            <p className="d-flex fw-bold mb-0">
              URL suggestions for
              <span className="search-item">&nbsp;"{showSearchItem}"</span>
            </p>
          </div>
        )}
        {isLoading && <Loader />}
        {tabs.length > 0 && <MobileSupportTabBar tabs={tabs} />}
      </div>
    </div>
  );
}
